// Package Imports
import { useSelect } from '@refinedev/antd';
import { HttpError, UseSelectProps } from '@refinedev/core';

// Project Imports
import resourceName from 'core/common/resourceName';

export interface UnifiedSource {
  unique_id: string;
  unified_source_name: string;
}

export default function getUnifiedList() {
  const useSelectParameter: UseSelectProps<
    UnifiedSource,
    HttpError,
    UnifiedSource
  > = {
    resource: `${resourceName.unifiedSourceMaster}`,
    dataProviderName: 'unifiedDataProvider',
    optionLabel: 'unified_source_name',
    optionValue: 'unique_id',
    meta: {
      type: 'select',
    },
  };
  const { selectProps } = useSelect(useSelectParameter);
  return (selectProps as any)?.options;
}
